import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, ModifySectionSecondsSchema, Transitions } from "../../types"
import { getServiceErrorMessage } from "../../helpers"

export const modifySectionSecondsDrawerState: StateNodeConfig<
  Context,
  ModifySectionSecondsSchema,
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({ modifySectionSecondsModal: true }),
  exit: assign<Context>({
    modifySectionSecondsModal: false,
    selectedSectionId: null,
    targetSectionSeconds: null
  }),
  initial: "idle",
  states: {
    update_section_seconds_transition: {
      invoke: {
        src: "updateSectionSecond",
        onDone: {
          target: "#StudyPlan.edit_plan",
          actions: assign((_ctx, evt: DoneInvokeEvent<any>) => ({
            studyPlan: evt.data.plan,
            snackbar: {
              message: "Mastery Lesson hours have been modified",
              withUndo: true
            }
          }))
        },
        onError: {
          //target: "#StudyPlan.edit_plan",
          target: "idle",
          actions: assign<Context, DoneInvokeEvent<any>>({
            snackbar: (_ctx, evt) => ({
              message: getServiceErrorMessage("updateSectionSecond", {
                errorReason: evt.data.message
              }),
              withUndo: false,
              error: true
            })
          })
        }
      }
    },
    idle: {
      on: {
        "seconds.update": {
          actions: assign((_ctx, { seconds }) => ({
            targetSectionSeconds: seconds
          }))
        },
        SAVE_SECTION_SECOND: {
          target: "update_section_seconds_transition"
        },
        CANCEL: {
          target: "#StudyPlan.edit_plan",
          actions: assign((_ctx, _evt) => ({
            selectedSectionId: null,
            targetSectionSeconds: null
          }))
        }
      }
    }
  }
}
